import React from 'react';
import { isRenu } from '../utils/ui.utils'; // Import isRenu

function originInterior(data){
  if(data === 'cn'){
    return <div className="il-add" data-beta-flow="true" style={{ backgroundImage: `url("/img/origin/origin-cn-right.jpg")`}}></div>;	
  } else {
    return <div className="il-add" data-beta-flow="true" style={{ backgroundImage: `url("/img/origin/origin-eu-right.jpeg")`}}></div>;	
  }	
}

export const OriginVisual = ({ origin, down_type, lower, originExceptionFlag }) => {
  if (!origin) return null;

  // If originExceptionFlag is true, we force Hungary visuals
  const activeOrigin = originExceptionFlag ? "Hungary" : origin;

  // Logic for lower="left"
  if (lower === "left") {
    if (activeOrigin === "Hungary") {
      return (<div className="il-add" data-beta-flow="true" style={{ backgroundImage: `url("/img/origin/origin-hu-left.jpeg")`}}></div>);			  
    } else if (activeOrigin === "China") {	
      return (<div className="il-add" data-beta-flow="true" style={{ backgroundImage: `url("/img/origin/origin-cn-left.jpeg")`}}></div>);		
    } else { // Europe
      return (<div className="il-add" data-beta-flow="true" style={{ backgroundImage: `url("/img/origin/origin-eu-left.jpeg")`}}></div>);			  
    }
  }

  // Logic for lower="right"
  if (lower === "right") {	 	  
    if (activeOrigin === "Hungary") {
      return (<div className="il-add" style={{ backgroundImage: `url("/img/origin/origin-hu-right.jpeg")`}}></div>);			  
    } else if (activeOrigin === "China") {
      return ( originInterior('cn') );	  
    } else { // Europe
      return ( originInterior('eu') );	  
    }	  
  }

  // Default (upper) logic
  if (activeOrigin === "Hungary"){
    return (<div className="il-add" data-beta-flow="true" style={{ backgroundImage: `url("/img/origin/origin-hu-upper.jpeg")`}}></div>);			  
  } else if (activeOrigin === "China"){
    if(down_type === "White Duck"){
      return(<div className="il-add" data-beta-flow="true" style={{ backgroundImage: `url("/img/origin/origin-cn-wdd.min.jpg")`}}></div>);
    } else if(down_type === "Grey Duck"){
      return(<div className="il-add" data-beta-flow="true" style={{ backgroundImage: `url("/img/origin/origin-cn-gdd.min.jpg")`}}></div>);
    } else if(down_type === "Grey Goose"){
      return(<div className="il-add" data-beta-flow="true" style={{ backgroundImage: `url("/img/origin/origin-cn-ggd.min.jpg")`}}></div>);
    } else {
      return (<video className="il-add" data-beta-flow="true" src="/img/origin/origin-720.mp4" muted={true} preload="true" autoPlay={true} loop={true}></video>);
    }
  } else if(isRenu(down_type)){ 
    return (<div className="il-add" data-beta-flow="true" style={{ backgroundImage: `url("/img/origin/renu-blend.jpg")`}}></div>);	  
  } else {
    return (<div className="il-add" data-beta-flow="true" style={{ backgroundImage: `url("/img/origin/origin-eu-upper.jpeg")`}}></div>);	  
  }  
};
